import { makeStyles, Button, Container, Grid, Typography, TextField, Paper, Divider, Box, AppBar, Toolbar } from "@material-ui/core";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useParams, useHistory, generatePath } from 'react-router-dom'
import DrawerPanel from "./Drawer";
import CourseContentContainer from "./CourseContentContainer";
import bronze from '../../../images/bronze.svg';
//import data from '../curriculumData.json'
import QuizViewContainer from "./QuizViewContainer";
import { CurriculumDataService, CurriculumMasterData } from "../../../services";
import LazyImageLoader from "../commonComponents/LazyImageLoader";
import Loader from "../../../sharedComponents/Loader/Loader";
import { AppDataContext } from "../../../common/AppContext";
import CurriculumFinish from "./CurriculumFinish";
import GuestPromptRegister from "./GuestPrompRegister";
import RouteConstants from "../../../common/RouteConstants";
import Helper from "../../../common/Helper";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '100%',
    },
    headetText: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif !important',
        fontWeight: '600',
        color: '#8a5e1d',
    },
    headetSubText: {
        color: '#8a5e1d',
        paddingLeft: '8px',
        fontWeight: '500',
    },
    title: {
        fontSize: '1.4rem',
        fontWeight: 800
    }
}));

const CourseContent = () => {
    const history = useHistory()
    const classes = useStyles();
    const { addSnackMessages, user } = useContext(AppDataContext)
    const { state } = useLocation()
    const { id } = useParams()
    const [data, setData] = useState()
    const [sectionContent, setSectionContent] = useState();
    const [enableNext, setEnableNext] = useState(false);
    const [curriculumFlow, setCurriculumFlow] = useState([])
    const [currentSec, setCurrentSec] = useState('')
    const [completedSubIds, setCompletedSubIds] = useState([]);
    const [completedSecIds, setCompletedSecIds] = useState([])
    const [sectionTypeId, setSectionTypeId] = useState(0);
    const [isLoading, setIsLoading] = useState(false)
    const [isFishish, setIsFinish] = useState(false)
    const [userResponse, setUserResponse] = useState()
    const [showSignUp, setShowSignUp] = useState(false)

    useEffect(() => {

        const loadData = async () => {
            setIsLoading(true)
            //setData({ ...state?.curriculumData })
            Promise.allSettled([getCurriculumData(), state?.isPublic ? undefined : getCurriculumResponse()]).then((res) => {
                if (res[0].status === 'fulfilled') {
                    setData(res[0].value)
                    //setSectionContent(res[0].value?.sections[0]?.subSections[0])
                } else {
                    console.log("Error in getting curriculum data", res[0].reason);
                }
                if (res[1].status === 'fulfilled') {
                    setUserResponse(res[1].value ?? { userResponseDetails: [] })
                } else {
                    console.log("Error in getting curriculum response data", res[1].reason);
                }
            }).catch((err) => {
                console.log("Error in getting curriculum data", err);
            }).finally(() => {
                setIsLoading(false)
            })
        }
        if (id && id != 0) {
            loadData()
        }
    }, [id])

    const getCurriculumData = async () => {

        //setIsLoading(true)
        let res = undefined
        if (state?.isPublic) {
            res = await CurriculumDataService.getPublicCurriculumById(id)

        } else {
            let _payload = {
                curriculumID: id
            }
            res = await CurriculumDataService.getCurriculumById(_payload)
            // return res.data
        }

        if (res.data) {
            //setIsFinish(res.data.isFinished)
            return res.data
        } else {
            addSnackMessages([{
                open: true,
                severity: 'error',
                message: "Something went wrong, try again."
            }]);
            return null;
        }
        //     resolve(res.data)
        // }).catch(err => {
        //     console.log(err);
        //     reject(err)
        // addSnackMessages([{
        //     open: true,
        //     severity: 'error',
        //     message: "Something went wrong, try again."
        // }]);

    }

    const getCurriculumResponse = async () => {
        //return new Promise(async (resolve, reject) => {
        //let res = await CurriculumDataService.getCurriculumUserResponse(id)

        let res = await CurriculumDataService.getCurriculumUserResponse(id)
        return res;
        // console.log(err);
        // addSnackMessages([{
        //     open: true,
        //     severity: 'error',
        //     message: "  "
        // }]);

    }

    useEffect(() => {
        if (data && userResponse && curriculumFlow.length == 0) {
            let finalobj = []
            if (userResponse?.userResponseDetails.length == 0) {
                data.sections.forEach((section) => {

                    let key = section.sectionID
                    section.subSections.forEach((sub) => finalobj.push({ sectionId: key, subSectionId: sub.sectionID, disabled: true, completed: false, result: [] }))
                    if (userResponse?.id && userResponse?.id !== 0) {
                        let sec = data.sections[0]
                        let sub = sec.subSections[0]
                        setSectionContent(sub)
                        setCurrentSec(sec.sectionID)
                    }
                })
            } else {
                data.sections.forEach((section) => {
                    let key = section.sectionID
                    section.subSections.forEach((sub) => {

                        let obj = userResponse.userResponseDetails.filter(x => x.subSectionID == sub.sectionID)
                        if (obj.length > 0) {
                            let isCompleted = true
                            let quesResult = []
                            if (sub.questions.length > 0) {
                                let completedQuestions = userResponse.userResponseDetails.filter(x => x.subSectionID == sub.sectionID && x.questionID != 0)
                                if (completedQuestions.length > 0) {
                                    quesResult = completedQuestions.map(ques => {
                                        return { questionID: ques.questionID, isCompleted: ques.isComplete, answerGiven: ques.answerGiven, isCorrect: ques.isCorrect }
                                    })
                                }
                                if (sub.questions.length == completedQuestions.length) {
                                    isCompleted = true
                                } else {
                                    isCompleted = false
                                }

                            }
                            finalobj.push({ sectionId: key, subSectionId: sub.sectionID, disabled: false, completed: isCompleted, result: quesResult })
                        } else {
                            finalobj.push({ sectionId: key, subSectionId: sub.sectionID, disabled: true, completed: false, result: [] })
                        }
                    })
                })
                let incompleteIndex = finalobj.findIndex(x => x.completed == false)
                if (incompleteIndex > -1) {
                    let incompleteSubId = finalobj[incompleteIndex]
                    let sec = data.sections.find(x => x.sectionID == incompleteSubId.sectionId)
                    let sub = sec.subSections.find(x => x.sectionID == incompleteSubId.subSectionId)
                    setSectionContent(sub)
                    setCurrentSec(sec.sectionID)
                    finalobj[incompleteIndex]['disabled'] = false

                } else if (incompleteIndex == -1) {
                    let incompleteSubId = finalobj[finalobj.length - 1]
                    let sec = data.sections.find(x => x.sectionID == incompleteSubId.sectionId)
                    let sub = sec.subSections.find(x => x.sectionID == incompleteSubId.subSectionId)
                    setSectionContent(sub)
                    setCurrentSec(sec.sectionID)
                    finalobj[finalobj.length - 1]['disabled'] = false
                }

            }
            setCurriculumFlow(finalobj)
        }
    }, [data, userResponse])

    const onSectionContentShowClick = (sectionId, sec) => {
        setSectionContent(sec)
        setCurrentSec(sec.parentSectionID)
        console.log(sec);
        setEnableNext(false)
    }

    const updateNextButton = (value) => {
        // if (sectionContent && currentSec!='') {
        //     let currSubId = sectionContent.id
        //     let index = curriculumFlow.findIndex(x => x.subSectionId == currSubId)
        //     if (index > -1) {
        //         let obj = curriculumFlow[index]
        //         let newComSubIds = [...completedSubIds]
        //         let newComSecIds = [...completedSecIds]
        //         if (!completedSubIds.includes(obj?.subSectionId)) {

        //             newComSubIds.push(obj?.subSectionId)
        //         }
        //         let sec = data?.section.filter(x => x.id == currentSec)
        //         let subIds = sec.subSection.map(x => x.id)

        //         let completeSection = subIds.every((id) => newComSubIds.includes(id))
        //         if (completeSection) {
        //             let indexSec = completedSecIds.indexOf(currentSec)
        //             if (indexSec == -1) {

        //                 newComSecIds.push(currentSec)

        //             }
        //         }
        //         setCompletedSecIds(newComSecIds)
        //         setCompletedSubIds(newComSubIds)
        //     }
        setEnableNext(value)
        //}
    }

    const handleNextClick = (updatedFlow) => {
        let newCurrFlow = [...curriculumFlow]
        let currSubId = sectionContent?.sectionID
        let index = newCurrFlow.findIndex(x => x.subSectionId == currSubId)
        if (!isLast) {



            if (index > -1 && index < newCurrFlow.length) {
                if (state?.isPublic && index == 5 && (user == null || Object.keys(user).length == 0)) {
                    setShowSignUp(true)
                } else {
                    let next = newCurrFlow[index + 1]
                    let section = data.sections.find(x => x.sectionID == next?.sectionId)
                    if (section) {
                        let content = section.subSections.find(x => x.sectionID == next?.subSectionId)
                        let nextIndex = newCurrFlow.findIndex(x => x.subSectionId == next?.subSectionId)
                        newCurrFlow[nextIndex]['disabled'] = false
                        newCurrFlow[index]['completed'] = true
                        newCurrFlow[index]['result'] = updatedFlow
                        setCurrentSec(next?.sectionId)
                        setSectionContent(content)

                    }
                }
            }
        } else {
            let loggedIn = Helper.isUserLoggedIn()
            if (!state?.isFromBuilder && !state?.isPublic && loggedIn) {
                CurriculumDataService.updateCurriculumEndTime({ curriculumId: id })
                    .then(res => {
                        if (res.data == 0 && res.message && res.message.length > 0) {
                            addSnackMessages([{
                                open: true,
                                message: res.message,
                                severity: 'error'
                            }]);

                            return;
                        }
                        console.log("Curriculum end time updated successfully")
                    }).catch(err => {
                    })
            }
            setIsFinish(true)
            newCurrFlow[index]['completed'] = true
        }

        setCurriculumFlow(newCurrFlow)
    }

    const onPrevClick = () => {
        let currSubId = sectionContent?.sectionID
        let index = curriculumFlow.findIndex(x => x.subSectionId == currSubId)
        if (index > -1 && index < curriculumFlow.length) {
            let next = curriculumFlow[index - 1]
            let section = data.sections.find(x => x.sectionID == next?.sectionId)
            if (section) {
                let content = section.subSections.find(x => x.sectionID == next?.subSectionId)
                console.log(content);
                setCurrentSec(next?.sectionId)
                setSectionContent(content)
            }
        }
    }

    const handleStartClick = () => {
        if (!state?.isFromBuilder && !state?.isPublic && Helper.isUserLoggedIn()) {
            CurriculumDataService.updateCurriculumStartTime({ curriculumId: id })
                .then(res => {
                    if (res.data == 0 && res.message && res.message.length > 0) {
                        addSnackMessages([{
                            open: true,
                            message: res.message,
                            severity: 'error'
                        }]);

                        return;
                    }
                    console.log("Curriculum start time updated successfully")
                }).catch(err => {
                })
        }
        let newCurrFlow = [...curriculumFlow]
        let next = newCurrFlow[0]
        let section = data.sections.find(x => x.sectionID == next?.sectionId)
        let content = section.subSections.find(x => x.sectionID == next?.subSectionId)
        console.log(content);
        let index = newCurrFlow.findIndex(x => x.subSectionId == next?.subSectionId)
        newCurrFlow[index]['disabled'] = false
        setCurrentSec(next?.sectionId)
        setSectionContent(content)
        setCurriculumFlow(newCurrFlow)
    }

    const isFirst = useMemo(() => {
        if (sectionContent) {
            let sec = curriculumFlow[0]
            if (sec.subSectionId === sectionContent.sectionID) {
                return true
            }
            return false
        }

    }, [sectionContent])

    const isLast = useMemo(() => {
        if (sectionContent) {
            let sec = curriculumFlow[curriculumFlow.length - 1]
            if (sec.subSectionId === sectionContent.sectionID) {
                return true
            }
            return false
        }

    }, [sectionContent])

    const disableStart = () => {
        if (curriculumFlow.length == 0) {
            return true
        }
        return false;
    }

    const onBackToDashboardClick = () => {
        history.push({ pathname: generatePath(RouteConstants.CREATE_CURRICULUM, { id: id }), state: { isFromPreview: true } })
    }


    return (<>

        <Paper square variant="outlined">
            <Box display="flex" alignItems="center" justifyContent="space-between" p={1.5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px' }}>
                <Typography variant="h6" component="h6" className={classes.title} color="primary">{data?.curriculumName}</Typography>
                <Box component="div" display="flex" alignItems="center" style={{ display: 'flex', alignItems: 'center' }}>
                    {state?.isFromBuilder && <Button variant="contained" color="secondary" style={{ marginRight: '8px' }} onClick={onBackToDashboardClick}>
                        Back
                    </Button>}
                    <LazyImageLoader
                        id={"loader"}
                        key={"loader"}
                        showImage="true"
                        documentName={data?.mediumIconName}
                        documentType="image"
                        className={classes.badgeIcon}
                        onClick={() => { return false; }}
                    ></LazyImageLoader>
                    <Typography component="h5" variant="h5" className={classes.headetText}>{data?.badgeName ?? 'NA'}</Typography>
                    <Typography variant="body1" className={classes.headetSubText}>{data?.curriculumLevelName}</Typography>
                    {/* <Button variant="contained" color='primary' onClick={(e) => setSectionTypeId(1)}> Preview Quiz </Button> */}
                </Box>
            </Box>
        </Paper>
        <Box className={classes.root}>
            <DrawerPanel currentSec={currentSec}
                activeSubId={sectionContent?.sectionID}
                courseSection={data?.sections ?? []}
                onSectionContentShowClick={onSectionContentShowClick}
                completedSecIds={completedSecIds}
                completedSubIds={completedSubIds}
                curriculumFlow={curriculumFlow}
                isFishish={isFishish}
            />
            {/* {sectionTypeId === 1 &&
                <QuizViewContainer>
                </QuizViewContainer>
            } */}
            {/* {sectionTypeId === 0 && */}
            {!isFishish && !showSignUp ? <CourseContentContainer content={sectionContent}
                updateNextBtnState={updateNextButton}
                enableNext={enableNext}
                handleNextClick={handleNextClick}
                onStartClick={handleStartClick}
                currentSec={currentSec}
                isPreview={state?.isFromBuilder}
                handlePrevClick={onPrevClick}
                isFirst={isFirst}
                isLast={isLast}
                disableStart={disableStart()}
                curriculumFlow={curriculumFlow}
                curriculumDescription={data?.shortDescription}
            /> :
                showSignUp ? <GuestPromptRegister /> :
                    <CurriculumFinish />
            }
            {/* } */}
        </Box>
        <Loader isLoading={isLoading} />
    </>
    )
}

export default CourseContent;